// src/pages/Users/Techniques/hooks/useTechniqueSpeech.js

import { useMemo } from "react";
import { toKana } from "wanakana";

import { hasJapaneseCharacters } from "../utils/speechUtils";

export default function useTechniqueSpeech(
  name,
) {
  return useMemo(() => {
    const rawName = String(
      name || "",
    ).trim();

    if (!rawName) {
      return "";
    }

    if (
      hasJapaneseCharacters(rawName)
    ) {
      return rawName;
    }

    const cleanedName = rawName
      .replace(/[’']/g, "")
      .replace(/[-_]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();

    try {
      return toKana(cleanedName, {
        IMEMode: true,
      });
    } catch {
      return cleanedName;
    }
  }, [name]);
}